import React, { createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const NewSizeGuideContext = createContext({});

const tabs = [
  {
    name: 'SIZE CHART',
    id: 'tab_0',
  },
  {
    name: 'HOW TO MEASURE',
    id: 'tab_1',
  },
];

export const NewSizeGuideProvider = ({ children, data, isProductPage }) => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state['demo-saba']);

  const [activeGuide, setActiveGuide] = useState(null);
  const [activeTab, setActiveTab] = useState(tabs[0].id);
  const [activeRow, setActiveRow] = useState(null);
  const [sizeFormat, setSizeFormat] = useState('cm');
  const [showChat, setShowChat] = useState(false);

  const setShowDialog = useCallback(() => {
    dispatch({ type: 'close-sizeguide' });
  }, [dispatch]);

  const categories = useMemo(() => {
    return data?.guide.map((item) => {
      return {
        name: item.categoryName,
        sub: item.subcategoryGuide.map((subItem) => {
          return {
            categoryName: item.categoryName,
            name: subItem.subcategoryName,
            idsArray: subItem.subcategoryIds || [],
            label: `${item.categoryName} ${subItem.subcategoryName}`,
            lineItems: subItem?.lineItems,
            sizeConversation: item?.sizeConversation,
            measureData: {
              measureMedia: subItem?.measureMedia,
              measureOptions: subItem?.measureOptions?.some((x) => x.optionText || x.optionTitle)
                ? subItem?.measureOptions
                : null,
              measureTitle: subItem?.measureTitle || null,
            },
          };
        }),
      };
    });
  }, [data]);

  const availableCategoryIds = useMemo(() => {
    let subcategoryIds = [];
    categories.forEach((category) => {
      category.sub.forEach((subcategory) => {
        subcategory.idsArray.forEach((idsObj) => {
          subcategoryIds.push(idsObj.subcategoryId);
        });
      });
    });
    return subcategoryIds;
  }, [categories]);

  useEffect(() => {
    dispatch({
      type: 'availableIds-sizeguide',
      availableCategoryIds,
    });
  }, []);

  useEffect(() => {
    if (isProductPage) {
      const currentCategory = categories.map((x) => {
        return x.sub.find((subCat) => {
          return subCat?.idsArray?.some((item) =>
            state?.sizeGuideProductData?.categoryIds?.includes(item.subcategoryId),
          );
        });
      });

      return setActiveGuide(currentCategory?.filter((x) => x !== undefined)[0]);
    }

    setActiveGuide(categories?.[0]?.sub?.[0]);
  }, [categories, state]);

  const getNumber = (str) => {
    return str.replace(/\D/g, '');
  };

  const isHasMeasureTab = activeGuide
    ? Object.values(activeGuide?.measureData).every((element) => !!element || !!element?.media)
    : true;

  const setActiveDefaultTab = () => {
    const tabElement = document?.querySelector('[data-tabindex="tab_0"]');
    tabElement && tabElement.children[0].click();
    setActiveTab('tab_0');
  };

  useEffect(() => {
    if (!isHasMeasureTab) {
      setActiveDefaultTab();
    }
  }, [isHasMeasureTab]);

  const values = useMemo(() => {
    return {
      activeGuide,
      setActiveGuide,
      categories,
      activeTab,
      setActiveTab,
      activeRow,
      setActiveRow,
      sizeFormat,
      setSizeFormat,
      data,
      tabs,
      isProductPage,
      isHasMeasureTab,
      state,
      setShowDialog,
      getNumber,
      setActiveDefaultTab,
      showChat,
      setShowChat,
    };
  }, [
    data,
    categories,
    activeRow,
    activeGuide,
    activeTab,
    sizeFormat,
    isProductPage,
    isHasMeasureTab,
    state,
    showChat,
  ]);

  return <NewSizeGuideContext.Provider value={values}>{children}</NewSizeGuideContext.Provider>;
};
